import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const StyledText = styled(Typography)`
	${({ theme, type }) => theme.typography[type || "allVariants"]}
	color: ${({ theme, color }) => theme.palette[color || "primary"].text};
`;
